import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface ShopDismissals {
  askCard?: boolean;
  shipmentsBanner?: boolean;
}

export interface IAiPromoState {
  dismissals: Record<string, ShopDismissals>;
}

const initialState: IAiPromoState = { dismissals: {} };

const aiPromoSlice = createSlice({
  name: 'aiPromo',
  initialState,
  reducers: {
    dismissAskCard: (state, action: PayloadAction<string>) => {
      const shop = action.payload;
      state.dismissals[shop] = { ...state.dismissals[shop], askCard: true };
    },
    dismissShipmentsBanner: (state, action: PayloadAction<string>) => {
      const shop = action.payload;
      state.dismissals[shop] = { ...state.dismissals[shop], shipmentsBanner: true };
    },
  },
});

export const { dismissAskCard, dismissShipmentsBanner } = aiPromoSlice.actions;

export const makeAskCardDismissedSelector = (shop: string) =>
  createSelector(
    (state: RootState) => state.aiPromo.dismissals,
    (dismissals) => !!dismissals[shop]?.askCard,
  );

export const makeShipmentsBannerDismissedSelector = (shop: string) =>
  createSelector(
    (state: RootState) => state.aiPromo.dismissals,
    (dismissals) => !!dismissals[shop]?.shipmentsBanner,
  );

export default aiPromoSlice;
